export default __webpack_public_path__ + "static/media/loader.c44865d4.png";